import DashboardActionTypes from './DashboardActionTypes'

export interface DayTransitionDetected {
  type: typeof DashboardActionTypes.DAY_TRANSITION_DETECTED
  payload: {
    previousDay: string
    currentDay: string
  }
}

export interface DayTransitionRefresh {
  type: typeof DashboardActionTypes.DAY_TRANSITION_REFRESH
}

export const dayTransitionDetected = (
  previousDay: string,
  currentDay: string
): DayTransitionDetected => ({
  type: DashboardActionTypes.DAY_TRANSITION_DETECTED,
  payload: {
    previousDay,
    currentDay,
  },
})

export const dayTransitionRefresh = (): DayTransitionRefresh => ({
  type: DashboardActionTypes.DAY_TRANSITION_REFRESH,
})